import { Colors, Services, isEmpty } from '@sigma-frontend-libs/commons'

import { buttonModes } from '@/utils'

import button from '@/components/button'
import fileManager from '@/components/file/manager'
import fileSticker from '@/components/file/sticker'

function renderFileSticker(h) {
  return h(
    fileSticker,
    {
      props: {
        value: this.payloadFile
      },
      on: {
        remove: this.clearHandler
      }
    }
  )
}
function renderButtonByFileType(h, type) {
  if (this.currentType == type && !isEmpty(this.payloadFile)) {
    return renderFileSticker.call(this, h)
  }

  return h(
    button,
    {
      props: {
        label: this.getTranslate(`buttons.upload.${type}`),
        color: Colors.info,
        mode: buttonModes.outline,
        fullWidth: true,
        disabled: this.disabled
      },
      on: {
        click: () => {
          return this.setCurrentType(type)
        }
      }
    }
  )
}
function renderButtons(h) {
  return this.typeCategories.map(category => {
    return renderButtonByFileType.call(this, h, category)
  })
}

function renderFileManager(h) {
  return h(
    fileManager,
    {
      props: {
        show: this.showFileManager,
        currentChosenFileId: this.payloadFile,
        flat: true,
        disabled: this.disabled,
        readonly: true,
        embedded: true,
        types: this.fileManagerTypes,
        isPublic: true
      },
      on: {
        input: ({ id }) => {
          return this.setFile(id)
        },
        show: event => {
          this.showFileManager = event
        }
      }
    }
  )
}

export default function(h) {
  return h(
    'div',
    {
      class: [
        [ `${Services.sendings}-create__form-attach` ],
        [ `${Services.sendings}-create__form-attach--${this.type}` ]
      ],
      key: this.type
    },
    [
      renderButtons.call(this, h),
      renderFileManager.call(this, h)
    ]
  )
}
